import React from 'react';
import RulesTable from '../components/RulesTable';
import PageHeader from '../components/PageHeader';
import useDocumentTitle from '../components/useDocumentTitle';

const Rules = () => {
    useDocumentTitle("Normatividad");
    return (
        <div>
            <PageHeader tittle="NORMATIVIDAD" />

            <RulesTable />
            

        </div>
    );
}
 
export default Rules;